import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAdminSession } from "./AdminSessionContext";

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAdminSession();

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background-100">
        <div className="w-8 h-8 rounded-full border-2 border-primary-200 border-t-primary-500 animate-spin" />
      </div>
    );
  }

  if (status === "unauthenticated") {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
}
